module.exports = __webpack_public_path__ + "img/photo-9-1.7b02294d.webp";